import { createRoutes } from './build';

export const routes = createRoutes({
  home: {
    path: '/dashboard',
  },

  reward: {
    path: '/reward',
  },
  account: {
    path: '/account',
  },

  auth: {
    path: '/auth',

    isOpen: true,

    queryParams: ['code'] as const,

    children: {
      'forgot-password': {
        path: '/forgot-password',
        isOpen: true,
        queryParams: ['token'] as const,
      },
    },
  },

  // 'registration-complete': {
  //   path: '/registration/complete',
  //   isOpen: true,
  //   queryParams: ['code'] as const,
  // },
});

export type RoutesType = typeof routes;

export type AppRoute = keyof RoutesType;
